module.exports = __webpack_public_path__ + "img/nav-right-with-contact-toolbar-hyundai.05f1d4ca.png";